import { useState } from 'react'

import { ClampingText, ClampingTextButtonTail } from '../../ClampingText'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, number, text } from '../Controls'

import { CLAMPING_TEXT_FULL_TEXT } from './ClampingText.mocks'

export function ClampingTextUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(number('clampingLinesCount', 3))
      .add(text('fullText', CLAMPING_TEXT_FULL_TEXT))
      .add(boolean('canEdit', true))
  )

  const isEdit = props.controls.canEdit.value

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  const clampingConfig = {
    Tail: ClampingTextButtonTail,
    canEdit: true,
    onClick: () => {
      alert('modal')
    },
  }

  if (isEdit) {
    return (
      <>
        <Component
          {...props.getValues()}
          isNodeClamp
          Component={ClampingText}
          clampingConfig={clampingConfig}
          name='ClampingText'
          onChange={handleChange}
        />
        <ComponentProps name='ClampingText' value={props} onChange={setProps} />
      </>
    )
  }

  return (
    <div>
      <Component
        {...props.getValues()}
        Component={ClampingText}
        name='ClampingText'
        onChange={handleChange}
      />

      <ComponentProps name='ClampingText' value={props} onChange={setProps} />
    </div>
  )
}
